import { render, staticRenderFns } from "./extraFileds.vue?vue&type=template&id=2b87e36c"
import script from "./extraFileds.vue?vue&type=script&lang=js"
export * from "./extraFileds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports